const state = {
  countriesArr: [],
  activeStep: 'SelectPlanStep',
  modalOpened: false,
  userAuthenticated: false,
  userData: '',
  selectedPlan: '',
  couponPlan: '',
  couponCode: '',
  deliveryMethod: 'pocztaPolska',

  isGift: false,
  giftData: {
    isGift: false,
    deliveryMethod: 'sendEmail',
    name: '',
    email: '',
    message: ''
  },
  paymentMethod: '',
};
export default state;
